// extracted by mini-css-extract-plugin
module.exports = {"camp-J":"J_camp-J__W4xCj"};